(() => {
  const initializeHelpGuides = () => {
    document.querySelectorAll('[data-rpg-help-guide]').forEach((guide) => {
      if (guide.dataset.rpgHelpReady === 'true') return;

      const dialog = guide.querySelector('.rpg-badge-dialog');
      const content = guide.querySelector('[data-rpg-badge-content]');
      const closeButton = guide.querySelector('[data-rpg-badge-close]');
      if (!dialog || !content || !closeButton) return;

      guide.dataset.rpgHelpReady = 'true';
      guide.addEventListener('click', (event) => {
        const badge = event.target.closest('[data-rpg-help-badge]');
        if (!badge || !guide.contains(badge)) return;

        const template = guide.querySelector(`[data-rpg-badge-template="${badge.dataset.rpgHelpBadge}"]`);
        if (!template) return;

        content.replaceChildren(template.content.cloneNode(true));
        if (['fair', 'good', 'excellent'].includes(badge.dataset.rpgHelpBadge)) {
          const note = guide.querySelector('[data-rpg-badge-template="grade-note"]');
          if (note) content.append(note.content.cloneNode(true));
        }

        dialog.showModal();
        document.documentElement.classList.add('rpg-dialog-open');
      });

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => document.documentElement.classList.remove('rpg-dialog-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      const shopifyChatButton = guide.querySelector('[data-rpg-open-shopify-chat]');
      if (shopifyChatButton) {
        const getActivator = () => document
          .querySelector('shopify-chat')
          ?.shadowRoot
          ?.querySelector('[part="activator"]');

        shopifyChatButton.addEventListener('click', () => getActivator()?.click());
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initializeHelpGuides);
  document.addEventListener('shopify:section:load', initializeHelpGuides);
})();
